//mui imports==========
import useStyles from './styles';
import { TextField } from '@mui/material';
//=====================

const TextInput = ({ val, label, onChange, inputType, editable }) => {
	const classes = useStyles();

	return (
		<TextField
			id="outlined-size-normal"
			style={{ width: '100%', margin: '1rem 0' }}
			value={val}
			label={label}
			onChange={(e) => onChange(e.target.value)}
			type={inputType}
			disabled={editable === false}
		/>
	);
};

export default TextInput;
